(() => {
  'use strict';
  const freeRegions = new Set(['US', 'JP', 'HK', 'TW']);
  const supportedRegions = new Set('AU AT BN CA FI FR DE GL IE IT MX NL NZ SG KR ES SE CH TH GB DK NO IS LV EE LT BE CZ MY PT AE ID LK MN VN PA BG HR LI HU MK LU SM RS AD GR MD MC SK SI VA BA BY RO AL MT ME TR PL US JP HK TW'.split(' '));
  const config = document.getElementById('rs-shipping-config');
  const splitHandles = new Set(config ? JSON.parse(config.textContent).splitHandles.map(handle => handle.trim()) : ['amberglow-ultra-light-hiking-flashment-1']);
  let lastCart = null;
  class RidgeSongShippingGoal extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-shipping-status]');
      this.progress = this.querySelector('[data-shipping-progress]');
      this.update(lastCart);
    }
    update(cart, busy = false) {
      const country = this.dataset.country;
      const total = Number(cart?.total_price ?? this.dataset.total);
      const currency = cart?.currency || this.dataset.currency;
      const threshold = Number(this.dataset.threshold);
      let message = this.dataset.confirmation;
      this.progress.hidden = true;
      if (!supportedRegions.has(country)) {
        message = this.dataset.unsupported;
      } else if (!busy && currency === 'USD' && total > 0 && Number.isFinite(total)) {
        if (freeRegions.has(country)) {
          if (total >= 990) message = this.dataset.free;
        } else if (threshold > 0 && total >= threshold) {
          message = this.dataset.free;
        } else if (threshold > total) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD',currencyDisplay:'code'}).format((threshold - total) / 100);
          message = this.dataset.remaining.replace('__AMOUNT__', amount);
          this.progress.value = Math.min(total / threshold * 100, 100);
          this.progress.hidden = false;
        }
      }
      this.status.textContent = message.replace('__COUNTRY__', this.dataset.countryName);
    }
  }
  if (!customElements.get('rs-shipping-goal')) customElements.define('rs-shipping-goal', RidgeSongShippingGoal);
  const update = (cart, busy = false) => {
    if (cart) lastCart = cart;
    document.querySelectorAll('rs-shipping-goal').forEach(node => node.update(cart || lastCart, busy));
    if (cart?.items) {
      const split = cart.items.some(item => splitHandles.has(item.handle));
      document.querySelectorAll('[data-rs-split-notice]').forEach(node => { node.hidden = !split; });
    }
  };
  document.addEventListener('cart:updated', event => update(event.detail?.cart));
  document.addEventListener('rs:gift-cart-ready', event => update(event.detail?.cart));
  document.addEventListener('rs:shipping-cart', event => update(event.detail?.cart, event.detail?.busy));
  document.addEventListener('rs:cart-mutating', () => update(lastCart, true));
})();
